import $ from "jquery";


const init = () => {
  handlerHeader();
};

const el = {
  main: ".mi-Header",
  headerLogo: ".mi-Header-Logo div a img",
  headerMenu: ".mi-Header-Menu",
  inner: ".mi-Header-Inner",
  hamburgerMenu: ".mi-Hamburger-Menu",
};

const originUrl = window.location.origin;
const logoColored =
  "/wp-content/themes/hello-theme-child-master/mi-themes-child/assets/images/logo-colored.svg";

const handlerHeader = () => {
  const header = $(el.main);
  const headerLogo = $(el.headerLogo);
  const headerMenu = $(el.headerMenu);
  const innerHeader = $(el.inner);

  const currentLogoUrl = headerLogo.attr("src");

  const hamburgerBtn = $(el.hamburgerMenu).find("svg, i");

  if (header.length === 0) return;

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        if (header.hasClass("elementor-sticky--effects")) {
          innerHeader.addClass("active");
          headerMenu.addClass("active");

          headerLogo.attr("src", `${originUrl}${logoColored}`);
          hamburgerBtn.css("fill", "#111");
          hamburgerBtn.css("color", "#111");
        } else {
          innerHeader.removeClass("active");
          headerMenu.removeClass("active");

          headerLogo.attr("src", `${currentLogoUrl}`);
          hamburgerBtn.css("fill", "#fff");
          hamburgerBtn.css("color", "#fff");
        }
      }
    });
  });

  const targetNode = document.querySelector(el.main);
  if (targetNode) {
    const config = { attributes: true };
    observer.observe(targetNode, config);
  }
};

try {
  init();
} catch (error) {
  console.log(`Error Handler Header: `, error);
}
